module.exports = __webpack_public_path__ + "img/9.91c51f72.jpg";